import { DropdownMenu } from '../../form';
import { Icon } from '../../UI';
import React from 'react';
import { DropdownMenuPropsModel } from '../../form/Dropdown-menu/dropdown-menu-props.model';

export interface CardProps {
  children: any;
  header?: JSX.Element;
  footer?: JSX.Element;
  title?: string;
  className?: string;
  padding?: boolean;
  menuItems?: DropdownMenuPropsModel['dropdownItems'];
}

export const Card = ({
  className = '',
  padding = true,
  children,
  header,
  footer,
  title,
  menuItems,
}: CardProps) => {
  return (
    <div
      className={`
        shadow-md
        border
        border-grey-10
        dark:border-grey-70
        w-full
        rounded-xl
        dark:bg-grey-90
        dark:text-white
        ${className}
      `}
    >
      {header && React.isValidElement(header) && (
        <div className={'border-b border-grey-10 dark:border-grey-70'}>
          {header}
        </div>
      )}
      {!header && title && (
        <div className="flex justify-between border-b px-5 py-3 border-grey-10 dark:border-grey-80">
          {title && <p className="font-bold uppercase">{title}</p>}
          {menuItems && (
            <DropdownMenu
              dropdownItems={menuItems}
              dropdownClassName="self-center"
              dropdownTooltipClassName="bg-white border-solid border-grey-10 border shadow-md"
            >
              <Icon svgName={'options'} className={'cursor-pointer'} />
            </DropdownMenu>
          )}
        </div>
      )}
      <div className={padding ? 'px-5 py-6' : 'p-0'}>{children}</div>
      {footer && React.isValidElement(footer) && (
        <div className={'border-t border-grey-10 dark:border-grey-70'}>
          {footer}
        </div>
      )}
    </div>
  );
};
